import { Select, TextInput } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { propertyTypeEnum } from '@markku/db'
import { PROPERTY_TYPE_LABELS } from '@markku/utils'
import { InfoFormValues, Property } from './types'

interface PropertySelectorProps {
  properties: Property[]
  selectedPropertyId: string | null
  onPropertyChange: (value: string | null) => void
  showAddressFields: boolean
  form: UseFormReturnType<InfoFormValues>
}

const PROPERTY_TYPES = propertyTypeEnum.enumValues.map((value) => ({
  value,
  label: PROPERTY_TYPE_LABELS[value],
}))

export function PropertySelector({
  properties,
  selectedPropertyId,
  onPropertyChange,
  showAddressFields,
  form,
}: PropertySelectorProps) {
  const propertyOptions = [
    ...properties.map((p) => ({
      value: String(p.id),
      label: p.address
        ? `${p.address.street}, ${p.address.postalCode || ''} ${p.address.city}`
        : `Kiinteistö ${p.id}`,
    })),
    { value: 'other', label: 'Muu osoite' },
  ]

  return (
    <>
      {properties.length > 0 && (
        <Select
          label="Kiinteistö"
          placeholder="Valitse kiinteistö"
          data={propertyOptions}
          value={selectedPropertyId}
          onChange={onPropertyChange}
          required
        />
      )}

      {showAddressFields && (
        <>
          <TextInput
            label="Osoite"
            placeholder="Esimerkkikatu 1"
            required
            autoComplete="address-line1"
            {...form.getInputProps('street')}
          />

          <TextInput
            label="Postinumero"
            placeholder="00100"
            required
            maxLength={5}
            autoComplete="postal-code"
            {...form.getInputProps('postalCode')}
          />

          <Select
            label="Kiinteistön tyyppi"
            placeholder="Valitse tyyppi"
            data={PROPERTY_TYPES}
            required
            {...form.getInputProps('propertyType')}
          />
        </>
      )}
    </>
  )
}
